export default __webpack_public_path__ + "static/media/registered.bd270c7a.svg";